import { businessKey } from 'queryKeys';

const TRACKER = 'tracker';
const ANNOTATIONS = 'annotations';
const METRICS = 'metrics';
const COHORTS = 'cohorts';
const METRICS_LIST = 'metricsList';
const METRIC_GROUPS = 'metricGroups';
const DRILL_TO = 'drillTo';
const DIMENSIONS = 'dimensions';
const FAVOURITE_METRICS = 'favouriteMetrics';
const FAVOURITE_METRIC_FILTERS = 'favouriteMetricFilters';
const FILTER_DETAILS = 'filterDetails';

const MUTATION_EXPORT_FROM_GOOGLE_DRIVE = 'exportGoogleDrive';
const MUTATION_EXPORT_FROM_GOOGLE_DRIVE_COHORTS = 'exportGoogleDriveCohorts';
const MUTATION_EXPORT_FROM_GOOGLE_DRIVE_CHART = 'exportGoogleDriveChart';
const MUTATION_EXPORT_COHORTS = 'exportCohorts';
const MUTATION_EXPORT_CHART = 'exportChart';
const MUTATION_EXPORT_TABLE = 'exportTable';
const MUTATION_UPDATE_DYNAMIC_DATA = 'updateDynamicData';
const MUTATION_REQUEST_EMAIL = 'requestEmail';
export const atQuery = businessKey.query(TRACKER);

const atGridsQuery = atQuery.query('grid');
export const grids = () => atGridsQuery.all();
export const mainGrid = atGridsQuery.exact('main');
export const expandedGrid = atGridsQuery.exact('expanded');

export const chart = atQuery.chart();

export const charts = atQuery.charts();
export const annotations = atQuery.exact(ANNOTATIONS);
export const dimensions = atQuery.exact(DIMENSIONS);
export const cohorts = atQuery.exact(COHORTS);
export const drillTo = atQuery.exact(DRILL_TO);
export const favouriteMetrics = atQuery.exact(FAVOURITE_METRICS);
export const favouriteMetricFilters = atQuery.exact(FAVOURITE_METRIC_FILTERS);
export const filterDetails = atQuery.exact(FILTER_DETAILS);

const atMetricsQuery = atQuery.query(METRICS);

export const metrics = atMetricsQuery;

export const metricsList = atMetricsQuery.exact(METRICS_LIST);
export const metricGroups = atMetricsQuery.exact(METRIC_GROUPS);

export const mutations = atMetricsQuery.mutations();

export const loadCustomMetric = atMetricsQuery.details();
export const updateCustomMetric = mutations.update();

export const createCustomMetric = mutations.create();

export const removeCustomMetric = mutations.delete();

export const exportGoogleDrive = mutations.mutate(
  MUTATION_EXPORT_FROM_GOOGLE_DRIVE
);
export const exportGoogleDriveChart = mutations.mutate(
  MUTATION_EXPORT_FROM_GOOGLE_DRIVE_CHART
);
export const exportGoogleDriveCohorts = mutations.mutate(
  MUTATION_EXPORT_FROM_GOOGLE_DRIVE_COHORTS
);
export const exportCohorts = mutations.mutate(MUTATION_EXPORT_COHORTS);
export const exportChartKey = mutations.mutate(MUTATION_EXPORT_CHART);
export const exportTableKey = mutations.mutate(MUTATION_EXPORT_TABLE);
export const updateDynamicDataKey = mutations.mutate(
  MUTATION_UPDATE_DYNAMIC_DATA
);
export const requestMailKey = mutations.mutate(MUTATION_REQUEST_EMAIL);
